import { render, staticRenderFns } from "./AdminDashboardStatItem.vue?vue&type=template&id=34c11492&"
import script from "./AdminDashboardStatItem.vue?vue&type=script&lang=ts&"
export * from "./AdminDashboardStatItem.vue?vue&type=script&lang=ts&"
import style0 from "./AdminDashboardStatItem.vue?vue&type=style&index=0&id=34c11492&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports